module.exports = __webpack_public_path__ + "static/rissalaOrganics-bf6483625d4dde0c534ff7588d246c9b.png";